import React from 'react'
import MediaLibrary from './MediaLibrary'

const ClientMedia = () => {
  return <MediaLibrary />
}

export default ClientMedia